import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Button, Text, Flex } from "@chakra-ui/react";

interface Props {
  isOpen: boolean;
  fullName: string;
  email: string;
  message: string;
  onClose: () => void;
}

function SupportMessageModal({ isOpen, fullName, email, message, onClose }: Props) {
  return (
    <Modal blockScrollOnMount={true} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Support Message</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" alignItems="center">
            <Text mt={4} fontWeight="bold">
              {fullName}
            </Text>
            <Text>{email}</Text>
            <Text mt={4}>{message}</Text>
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SupportMessageModal;
  